import React from 'react';

import {Box, Stack, Skeleton} from 'views/components';

const CaregiverProfileSkeleton = (props) => {
  const accordionHeaderWidths = [160, 180, 180, 190];

  return (
    <Stack
      alignItems="center"
      width="100%"
      sx={{
        bgcolor: '#FAF9F6',
        minHeight: '100vh',
      }}
    >
      <Stack
        spacing={{
          xs: 3,
          md: 3,
        }}
        sx={{
          alignItems: 'center',
          maxWidth: {
            md: 700,
            lg: 1100,
          },
          width: 'calc(100% - 16px)',
          mx: 'auto',
          mt: {
            xs: 1.5,
            sm: 2,
          },
          mb: {
            xs: 25,
            sm: 15,
          },
          pt: {
            xs: 2,
            sm: 3,
            md: 4,
          },
          px: {
            xs: 3,
            sm: 3,
            md: 4,
          },
          bgcolor: '#FFFDFC',
          borderRadius: 4,
          border: '1px solid',
          borderColor: 'color.divider',
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
      >
        <Stack
          direction="column"
          spacing={{
            xs: 1,
            md: 2,
          }}
          alignItems="stretch"
          width="100%"
          sx={{
            pt: {
              xs: 2,
              md: 4,
            },
          }}
        >
          <Stack
            direction={{
              xs: 'column',
              md: 'row',
            }}
            spacing={{
              xs: 3,
              sm: 4,
            }}
            alignItems={{
              xs: 'center',
              sm: 'flex-start',
            }}
            width="100%"
            sx={{
              pb: 2,
            }}
          >
            <Skeleton
              variant="circular"
              sx={{
                width: {
                  xs: 80,
                  sm: 96,
                  md: 128,
                  lg: 152,
                },
                height: {
                  xs: 80,
                  sm: 96,
                  md: 128,
                  lg: 152,
                },
              }}
            />
            <Stack
              alignItems="flex-start"
              sx={{
                flex: 1,
              }}
              spacing={1}
              width="100%"
            >
              <Stack
                direction={{
                  xs: 'column',
                  md: 'row',
                }}
                spacing={{
                  xs: 1,
                  md: 1.5,
                }}
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  width: '100%',
                }}
              >
                <Stack
                  spacing={{
                    xs: 0.5,
                    md: 1,
                  }}
                  alignItems={{
                    xs: 'center',
                    md: 'start',
                  }}
                >
                  <Skeleton
                    variant="text"
                    height={42}
                    sx={{
                      width: {
                        xs: 100,
                        sm: 260,
                      },
                    }}
                  />
                  <Skeleton
                    variant="text"
                    height={24}
                    sx={{
                      width: {
                        xs: 120,
                        sm: 180,
                      },
                    }}
                  />
                </Stack>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{
                    pt: {
                      xs: 1,
                      md: 0,
                    },
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    width={112}
                    height={45}
                    sx={{
                      borderRadius: 2,
                      display: {
                        xs: 'none',
                        sm: 'block',
                      },
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={149}
                    height={45}
                    sx={{
                      borderRadius: 2,
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          <Skeleton
            variant="text"
            height={20}
            sx={{
              width: {
                xs: 180,
                sm: 240,
              },
            }}
          />
          <Stack
            sx={{
              p: 2,
              bgcolor: 'color.white',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'color.divider',
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Skeleton variant="text" height={20} />
            <Skeleton
              variant="text"
              height={20}
              sx={{
                width: '92%',
              }}
            />
            <Skeleton
              variant="text"
              height={20}
              sx={{
                width: '80%',
              }}
            />
          </Stack>
        </Stack>
        <Stack
          alignItems="flex-start"
          spacing={2}
          width="100%"
        >
          <Skeleton
            variant="text"
            height={20}
            sx={{
              width: {
                xs: 200,
                sm: 280,
              },
            }}
          />
          <Stack
            sx={{
              p: 2,
              bgcolor: 'color.white',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'color.divider',
              width: '100%',
              boxSizing: 'border-box',
            }}
          >
            <Skeleton variant="text" height={20} />
            <Skeleton
              variant="text"
              height={20}
              sx={{
                width: '95%',
              }}
            />
            <Skeleton
              variant="text"
              height={20}
              sx={{
                width: '88%',
              }}
            />
            <Skeleton
              variant="text"
              height={20}
              sx={{
                width: '70%',
              }}
            />
          </Stack>
        </Stack>
        <Stack
          spacing={0}
          width="100%"
          sx={{
            mx: {
              xs: -3,
              sm: -3,
              md: -4,
            },
            width: {
              xs: 'calc(100% + 48px)',
              sm: 'calc(100% + 48px)',
              md: 'calc(100% + 64px)',
            },
          }}
        >
          {
            accordionHeaderWidths.map((headerWidth, index) => (
              <Stack
                key={`accordion-${index}`}
                sx={{
                  width: '100%',
                  bgcolor: '#F8F6EF',
                  border: '1px solid',
                  borderColor: 'color.divider',
                }}
              >
                <Box
                  sx={{
                    px: 3,
                    py: 2,
                    minHeight: {
                      xs: 64,
                      sm: 72,
                    },
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Skeleton
                    variant="text"
                    height={28}
                    sx={{
                      width: headerWidth,
                    }}
                  />
                </Box>
              </Stack>
            ))
          }
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CaregiverProfileSkeleton;
